import { render, staticRenderFns } from "./BlockableSection.vue?vue&type=template&id=694634e8&scoped=true"
import script from "./BlockableSection.vue?vue&type=script&lang=ts"
export * from "./BlockableSection.vue?vue&type=script&lang=ts"
import style0 from "./BlockableSection.vue?vue&type=style&index=0&id=694634e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694634e8",
  null
  
)

export default component.exports